var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "width": "710",
      "title": "编辑客户权限"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "formItem-content"
  }, [_c('div', {
    staticClass: "formItem-left"
  }, [_c('FormItem', {
    attrs: {
      "label": "评分",
      "prop": "rating"
    }
  }, [_c('InputNumber', {
    attrs: {
      "max": 100,
      "min": 0,
      "placeholder": "评分"
    },
    model: {
      value: _vm.formItem.rating,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "rating", $$v);
      },
      expression: "formItem.rating"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "允许开发",
      "prop": "allowDev"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.isAllowDev,
      callback: function ($$v) {
        _vm.isAllowDev = $$v;
      },
      expression: "isAllowDev"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("是")]), _c('Radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("否")])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.status,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "status", $$v);
      },
      expression: "formItem.status"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("无")]), _c('Radio', {
    attrs: {
      "label": "dev"
    }
  }, [_vm._v("开发中")]), _c('Radio', {
    attrs: {
      "label": "supplying"
    }
  }, [_vm._v("供货中")]), _c('Radio', {
    attrs: {
      "label": "receive"
    }
  }, [_vm._v("收尾款中")]), _c('Radio', {
    attrs: {
      "label": "sue"
    }
  }, [_vm._v("起诉中")])], 1)], 1), _c('FormItem', {
    attrs: {
      "label": "所属部门",
      "prop": "department"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.department,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "department", $$v);
      },
      expression: "formItem.department"
    }
  }, _vm._l(_vm.departmentList, function (department) {
    return _c('Option', {
      key: department._id,
      attrs: {
        "value": department._id
      }
    }, [_vm._v(_vm._s(department.name))]);
  }), 1)], 1)], 1), _c('div', {
    staticClass: "formItem-right"
  }, [_c('FormItem', {
    attrs: {
      "label": "开发人员",
      "prop": "devSales"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.devSales,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "devSales", $$v);
      },
      expression: "formItem.devSales"
    }
  }, _vm._l(_vm.simpleUserList.filter(function (x) {
    return !x.superAdmin;
  }), function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "维护人员",
      "prop": "maintainSales"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.maintainSales,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "maintainSales", $$v);
      },
      expression: "formItem.maintainSales"
    }
  }, _vm._l(_vm.simpleUserList.filter(function (x) {
    return !x.superAdmin;
  }), function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "回款人员",
      "prop": "paymentSales"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.paymentSales,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "paymentSales", $$v);
      },
      expression: "formItem.paymentSales"
    }
  }, _vm._l(_vm.simpleUserList.filter(function (x) {
    return !x.superAdmin;
  }), function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "销售可见",
      "prop": "salesVisibleMember"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.salesVisibleMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "salesVisibleMember", $$v);
      },
      expression: "formItem.salesVisibleMember"
    }
  }, _vm._l(_vm.simpleUserList.filter(function (x) {
    return !x.superAdmin;
  }), function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "技术可见",
      "prop": "techVisibleMember"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: _vm.formItem.techVisibleMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "techVisibleMember", $$v);
      },
      expression: "formItem.techVisibleMember"
    }
  }, _vm._l(_vm.simpleUserList.filter(function (x) {
    return !x.superAdmin;
  }), function (user) {
    return _c('Option', {
      key: user._id,
      attrs: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.name))]);
  }), 1)], 1)], 1)]), _c('FormItem', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }